<template>
  <div class="container" @mouseleave="isMouseDown = false">
    <div class="container-carrousel">
      <div
        class="carrousel"
        :style="{
          transform: `rotateY(${lastMoveTo}deg)`,
          cursor: isMouseDown ? 'grabbing' : 'grab',
        }"
        @mousedown="mouseDownHandler"
        @mouseup="mouseUpHandler"
        @mousemove="mouseMoveHandler"
        @touchstart="touchStartHandler"
        @touchend="touchEndHandler"
        @touchmove="touchMoveHandler"
      >
        <div
          class="carrousel-item"
          v-for="n in 6"
          :key="n"
          :style="itemStyle(n)"
        >
          <p style="height: 100px">p</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMouseDown: false,
      currentMousePos: 0,
      lastMousePos: 0,
      lastMoveTo: 0,
      moveTo: 0,
      tz: 0,
    };
  },
  methods: {
    mouseDownHandler() {
      this.isMouseDown = true;
    },
    mouseUpHandler() {
      this.isMouseDown = false;
    },
    mouseMoveHandler(e) {
      if (this.isMouseDown) {
        this.getPosX(e.clientX);
      }
    },
    touchStartHandler() {
      this.isMouseDown = true;
    },
    touchEndHandler() {
      this.isMouseDown = false;
    },
    touchMoveHandler(e) {
      if (this.isMouseDown) {
        this.getPosX(e.touches[0].clientX);
      }
    },
    getPosX(x) {
      this.currentMousePos = x;
      this.moveTo =
        this.currentMousePos < this.lastMousePos
          ? this.moveTo - 2
          : this.moveTo + 2;
      this.lastMousePos = this.currentMousePos;
    },
    update() {
      this.lastMoveTo = this.lerp(this.moveTo, this.lastMoveTo, 0.05);
      requestAnimationFrame(this.update);
    },
    lerp(a, b, n) {
      return (a - b) * n + b;
    },
    createCarrousel() {
      // Aquí incluirías la lógica para ajustar el tamaño y posición de los elementos del carrusel
      // basado en el tamaño de la pantalla y otros factores.
    },
    itemStyle(n) {
      const degress = (360 / 6) * (n - 1); // Ajusta esto según el número total de elementos
      return {
        transform: `rotateY(${degress}deg) translateZ(${this.tz}px)`,
        backgroundImage: `url(https://picsum.photos/600/400?random=${n})`,
      };
    },
  },
  mounted() {
    this.update();
    this.createCarrousel();
    window.addEventListener('resize', this.createCarrousel);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.createCarrousel);
  },
};
</script>

<style scoped>
/* Tus estilos aquí */
</style>
